module.exports = __webpack_public_path__ + "static/media/image_26.2905c6b2.png";